import { Controller } from 'stimulus';

class DropoutController extends Controller {
  onDropoutClick() {
    const dropoutType = this.data.get('type');

    if (dropoutType === 'search') {
      this.focusSearchBar();
    }
  }

  focusSearchBar() {
    setTimeout(() => {
      this.searchBarTarget.querySelector('input').focus();
    }, 350);
  }
}

DropoutController.targets = [
  'searchBar',
];

export default DropoutController;
